import React, { forwardRef } from 'react';

import MUIMenuItem, {
  MenuItemProps as MUIMenuItemProps,
} from '@material-ui/core/MenuItem';

interface MenuItemProps extends MUIMenuItemProps {}

const MenuItem = forwardRef<any, MenuItemProps>((props, ref) => {
  const { button = false, ...rest } = props;

  return (
    <MUIMenuItem {...rest} ref={ref}>
      {props.children}
    </MUIMenuItem>
  );
});

MenuItem.displayName = 'MenuItem';

export default MenuItem;
